import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgMail({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 4.5h14a3 3 0 013 3v9a3 3 0 01-3 3H5a3 3 0 01-3-3v-9a3 3 0 013-3zm0 2a1 1 0 00-1 1v9a1 1 0 001 1h14a1 1 0 001-1v-9a1 1 0 00-1-1H5zm1.486 3.857a1 1 0 011.029-1.715l2.942 1.766a3 3 0 003.086 0l2.942-1.766a1 1 0 111.03 1.715l-2.943 1.766a5 5 0 01-5.144 0l-2.942-1.766z"
        fill={color}
      />
    </svg>
  )
}

export default SvgMail
